<div class="d-flex justify-content-center mt-4">

</div>
<div class="d-flex flex-column justify-content-center mt-4">
    <div id="addNewBOperatorZeroBOperator" class="d-flex justify-content-center mt-2 addNewBOperatorZeroBOperator" (click)="addNewBOperator()" 
        *ngIf="viewAddBOperatorZeroBOperator()">
        <div class="d-flex align-items-center ">
            <i class="fa-solid fa-circle-plus fa-2x"></i>
            <span class="small span-icon">Add B Operator</span>
        </div>
    </div>
    <div class="accordion" id="accordionExample" *ngFor="let bOperator of listBOperator">
        <div class="accordion-item">
            <h2 class="accordion-header" id="headingOne">
                <button class="accordion-button header-accordion-style" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBOperator" aria-expanded="true" aria-controls="collapseBOperator">
                    {{getBOperatorId(bOperator)}}
                </button>
            </h2>
            <div id="collapseBOperator" class="accordion-collapse collapse show" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample">
                <div class="accordion-body">
                    <div class="row mt-4">
                        <div class="col-md-4">
                            <label for="bOperatorGlobalCustomerId" style="white-space: nowrap ;">BO Global Customer Id *</label>
                            <input type="text" [(ngModel)]="bOperator.bOperatorGlobalCustomerId"
                                [ngClass]="{'input-error': !bOperator || !bOperator.bOperatorGlobalCustomerId}" class="form-control"
                                id="bOperatorGlobalCustomerId" name="bOperatorGlobalCustomerId" placeholder="BOperatorGlobalCustomerId">
                        </div>
                        <div class="col-md-4">
                            <label for="bOperator" style="white-space: nowrap ;">B Operator *</label>
                            <select [(ngModel)]="bOperator.bOperator" class="form-select" [ngClass]="{'input-error': !bOperator || !bOperator.bOperator}" id="bOperator"
                                name="bOperator" (ngModelChange)="onChange($event, bOperator)">
                                <option value="IMSA">DEUTSCHE TELEKOM</option>
                                <option value="TELIA">TELIA</option>
                                <option value="ORANGE">ORANGE</option>
                                <option value="TIM">TIM</option>
                                <option value="SWISSCOM">SWISSCOM</option>
                            </select>
                        </div>
                        <div class="col-md-4" style="white-space: nowrap ;">
                            <label for="masterFleetManagerId">Master Fleet Manager Id</label>
                            <input type="text" [(ngModel)]="bOperator.masterFleetManagerId" class="form-control"
                                id="masterFleetManagerId" name="masterFleetManagerId" placeholder="MasterFleetManagerId">
                        </div>

                    </div>
                    
                    

                    <div class="row mt-2">
                        <div class="col-md-12">
                            <label for="note">Note</label>
                            <textarea class="form-control" id="note" rows="2" [(ngModel)]="bOperator.note"></textarea>
                        </div>
                    </div>

				</div>
            </div>
        </div>
        <div class="d-flex justify-content-between flex-row mt-2">

            <div (click)="addNewBOperator()" *ngIf="viewAddBOperator(bOperator)" style="cursor: pointer;">
                <div class="d-flex align-items-center ">
                    <i class="fa-solid fa-circle-plus fa-2x">

                    </i>
                    <span class="small span-icon">Add B Operator</span>
                </div>
            </div>

            <div (click)="removeBOperator(bOperator)"   class="removeBOperator">
                <div class="d-flex align-items-center ">
                    <i class="fa-solid fa-x fa-2x"></i>
                    <span class="small span-icon">Remove B Operator</span>
                </div>
            </div>





        </div>

    </div>



</div>

<div class="row mt-4">
    <span class="span-error" *ngIf="customerDataBOperatorFormDisabled()">Add at least one B Operator and fill in all
        mandatory fields marked with
        * to go to the next step</span>
</div>
<div class="d-flex justify-content-end mt-4">
    <button class="btn btn-primary btn-lg active back-button btn-sm" (click)="backToStepLeadOperator()">Back</button>
    <button class="btn btn-primary btn-lg active btn-sm" style="margin-left:2%;"
        [disabled]="customerDataBOperatorFormDisabled()" (click)="goToStepCustomerCOuntry()">Next</button>
    <button class="btn btn-primary btn-lg active button-reset btn-sm" [disabled]="disabledForm()"
        (click)="resetForm()">Reset</button>
</div>